import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { CyclistService } from '../../../../../../../services/cyclist.service';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { CollectionsService } from '../../../../../../../services/collections.service';
import moment from 'moment';
import { Calendar } from 'primeng/calendar';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { UserService } from '../../../../../../../services/user.service';

@Component({
  selector: 'app-rental-reservation-job-card',
  templateUrl: './rental-reservation-job-card.component.html',
  styleUrls: ['./rental-reservation-job-card.component.scss'],
})
export class RentalReservationJobCardComponent implements OnInit {
  @Input() partner;
  @Input() reservation;
  @Input() reservationPaymentHistory;
  @Input() cyclist;
  @Output() updateReservationData: EventEmitter<any> = new EventEmitter();

  @Input() categories;
  @Input() fullAccessoryList = [];
  @Input() brands;
  @Input() sizes;
  @Input() rentalStoreRules;
  @Input() affiliates;

  public countryData: any = {};
  public currentTimes: string[] = [];
  public selectedProductsTmp: any = [];
  public disabledDates: any = [];
  public datePickerDisabled: boolean = true;
  public minDate = new Date();
  public minCollectionDate = new Date();
  public maxCollectionDate = moment().add(2, 'year').toDate();
  public dateUpdated: boolean = false;
  public editStoreNotes: boolean = false;
  public readMoreClientNotes: boolean = false;
  public readMoreStoreNotes: boolean = false;
  public updatingStatus: boolean = false;
  public products: any = [];
  public bikesLoading: boolean = false;
  public filteredProducts: any = [];
  public editDate: boolean = false;
  public editDeliveries: boolean = false;
  public editProducts: boolean = false;
  public editAffiliate: boolean = false;
  public savingReservationProducts: boolean = false;
  public savingReservationDates: boolean = false;
  public busySavingCustomer: boolean = false;
  public busySavingAddress: boolean = false;
  public selectedCategories: any = null;
  public selectedBrands: any = null;
  public selectedSizes: any = null;
  public loadingAvailability: boolean = false;
  public availableDates: any = [];
  public availableSlots: any = [];
  public canEditReservation: boolean = false;
  public listBikesNotAvailable: any = [];
  public hasProductCustomQuestions: boolean = false;
  public availableTimeUnits: any = [];
  public selectedTimeUnit: any = null;
  public overrideDateControl: boolean = false;
  public rentalDaysMessage: string = '';
  public affiliateID: any = null;

  public disabledDeliveryDates : any = [];
  public disabledCollectionDates : any = [];
  public deliveryTimeSlots : any = [];
  public collectionTimeSlots : any = [];
  public addressOptions : any = [];
  public deliveryAddressLoading : boolean = false;
  public collectionAddressLoading : boolean = false;
  public addressSearch : string = "";
  public availableDeliveryDates : any = [];
  public availableCollectionDates : any = [];
  public serviceIndicatorRecords : any = [];


  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  public reservationStatuses = [
    { key: 1, label: 'Booked In' },
    { key: 10, label: 'Being Prepared' },
    { key: 20, label: 'Ready' },
    { key: 30, label: 'Out' },
    { key: 40, label: 'Being Checked' },
    { key: 50, label: 'Returned' },
    { key: 100, label: 'Cancel' },
  ];

  @ViewChild('clientNotes') clientNotes: any;
  @ViewChild('storeNotes') storeNotes: any;
  @ViewChild('calendar') calendar: Calendar;

  constructor(
    private rentalsService: RentalsService,
    private cyclistService: CyclistService,
    private userService: UserService,
    private helpersService: HelpersService,
    public messageService: MessageService,
    private collectionsService: CollectionsService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
  console.log(this.rentalStoreRules);

    if (
      !this.reservation.storeNotes ||
      this.reservation.storeNotes.length === 0
    ) {
      this.editStoreNotes = true;
    }

    this.countryData = this.helpersService.getCountryData();
    this.reservation.fromDate = moment(this.reservation.fromDate).toDate();
    this.reservation.toDate = moment(this.reservation.toDate).toDate();

    if(this.minDate > this.reservation.fromDate){
      this.minDate = this.reservation.fromDate;
    }

    if (this.reservation.affiliate && this.reservation.affiliate.id) {
      this.affiliateID = this.reservation.affiliate.id;
    }

    this.overrideDateControl = true; //this.reservation.overrideDate;

    this.canEditReservation =
      this.reservation.reservationStatusID <= 30 ||
      this.reservation.fromDate > moment().toDate();
    if (this.partner.POSSystemID == 17) {
      this.canEditReservation = this.reservation.paymentStatusID == 10 ? false : true;
    }
    this.getReservation();
    this.getRentalAllowableTimeUnits();    
    this.updateButtonStatuses();    
    
  }

  ngAfterViewInit(): void {}

  ngOnChanges(changes: any): void {
    this.checkHasProductCustomQuestions();
  }

  getReservation() {
    this.rentalsService
      .getRentalReservation(
        this.reservation.defaultPartnerID,
        this.reservation.id,
      )
      .subscribe((reservation) => {
        this.updateReservationData.emit(reservation);      
        this.updateButtonStatuses();  
        this.checkHasProductCustomQuestions();

        if(reservation.reservationStatusID > 30 && reservation.reservationStatusID < 100){
          this.getReservationServiceIndicators();
        }

      });
  }

  updateButtonStatuses(){
    if(this.reservation.deliveryInformation && this.reservation.deliveryInformation.isDelivery){
      this.reservationStatuses = [
        { key: 2, label: 'Delivery' },
        { key: 10, label: 'Being Prepared' },
        { key: 20, label: 'Ready' },
        { key: 30, label: 'Out' },
        { key: 40, label: 'Being Checked' },
        { key: 51, label: 'Collected' },
        { key: 100, label: 'Cancel' },
      ];
    }else{
      this.reservationStatuses = [
        { key: 1, label: 'Booked In' },
        { key: 10, label: 'Being Prepared' },
        { key: 20, label: 'Ready' },
        { key: 30, label: 'Out' },
        { key: 40, label: 'Being Checked' },
        { key: 50, label: 'Returned' },
        { key: 100, label: 'Cancel' },
      ];
    }
  }

  checkHasProductCustomQuestions() {
    this.reservation.reservedProducts.forEach((product) => {
      if (
        product.customCategoryQuestions &&
        product.customCategoryQuestions.length > 0
      ) {
        this.hasProductCustomQuestions = true;
      }
    });
  }

  getRentalAllowableTimeUnits() {
    this.rentalsService
      .getRentalAllowableTimeUnits(this.helpersService.getPartnerId())
      .subscribe((units) => {
        this.availableTimeUnits = units;
        if (this.reservation.timeUnitID) {
          this.selectedTimeUnit = this.availableTimeUnits
            .filter((x) => {
              return x.id === this.reservation.timeUnitID;
            })
            .pop();
        }
      });
  }

  getClientNotesHeight() {
    return this.clientNotes &&
      this.clientNotes.nativeElement &&
      this.clientNotes.nativeElement.clientHeight
      ? this.clientNotes.nativeElement.clientHeight
      : 0;
  }

  getStoreNotesHeight() {
    return this.storeNotes &&
      this.storeNotes.nativeElement &&
      this.storeNotes.nativeElement.clientHeight
      ? this.storeNotes.nativeElement.clientHeight
      : 0;
  }

  isWaiverSigned() {
    return (
      !(
        this.rentalStoreRules.waiverTerms &&
        this.rentalStoreRules.waiverTerms.length > 0
      ) ||
      this.reservation.reservedProducts.filter((x) => {
        return x.waiverSigned;
      }).length === this.reservation.reservedProducts.length
    );
  }

  getProductsWithCustomQuestions() {
    return this.reservation.reservedProducts.filter((x) => {
      return x.customCategoryQuestions && x.customCategoryQuestions.length > 0;
    });
  }

  updateReservationStatus(value) {
    this.updatingStatus = true;
    var data = {
      ID: this.reservation.id,
      ReservationStatusID: value.key,
      LocalDateTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
    };
    var tmp = this.reservation.reservationStatusID;
    this.reservation.reservationStatusID = value.key;
    this.rentalsService.updateReservationStatus(data).subscribe(
      (reservation) => {
        this.updateReservationData.emit(reservation);

        if(reservation.serviceIndicatorRecords && reservation.serviceIndicatorRecords.length > 0){
          this.serviceIndicatorRecords = reservation.serviceIndicatorRecords;
        }

        this.updatingStatus = false;
      },
      (err) => {
        this.reservation.reservationStatusID = tmp;
        this.updatingStatus = false;
      },
    );
  }

  updateStoreNote() {
    var data = {
      ID: this.reservation.id,
      StoreNotes: this.reservation.storeNotes,
    };

    this.rentalsService.updateReservationStoreNotes(data).subscribe(
      (reservation) => {
        this.updateReservationData.emit(reservation);
        this.editStoreNotes = false;
      },
      (err) => {},
    );
  }

  setupDisabledDays() {
    //Just a temp setup to disable some days as per the dummy config passed from the root
    var disabledDates = [];
    var startDate = new Date(
      this.calendar.currentYear,
      this.calendar.currentMonth,
      1,
    );
    var endDate = moment(startDate).endOf('month').toDate();
    var current = startDate;
    while (current < endDate) {
      var dayOfWeek = moment(current).weekday();
      if (
        this.rentalStoreRules.storeTimes.filter((x) => {
          return (
            x.dayOfWeek == dayOfWeek &&
            x.startTime == '00:00:00' &&
            x.endTime == '00:00:00'
          );
        }).length > 0
      ) {
        disabledDates.push(current);
      }
      current = moment(current).add(1, 'days').toDate();
    }
    this.disabledDates = disabledDates;
  }

  filterRentalProducts() {
    this.filteredProducts = this.products;

    if (this.selectedCategories) {
      this.filteredProducts = this.filteredProducts.filter((x) => {
        return x.categoryName === this.selectedCategories;
      });
    }
    if (this.selectedBrands) {
      this.filteredProducts = this.filteredProducts.filter((x) => {
        return x.brand === this.selectedBrands;
      });
    }
  }

  selectCategoryFilter(value) {
    if (value === this.selectedCategories) {
      this.selectedCategories = null;
    } else {
      this.selectedCategories = value;
    }
    this.filterRentalProducts();
  }

  selectBrandFilter(value) {
    if (value === this.selectedBrands) {
      this.selectedBrands = null;
    } else {
      this.selectedBrands = value;
    }
    this.filterRentalProducts();
  }

  setSearch(value) {
    this.filteredProducts = this.products.filter((x) => {
      return (
        x.brand.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.model.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.categoryName.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        (x.serialNumber && x.serialNumber.toLowerCase().indexOf(value.toLowerCase()) > -1)
      );
    });
  }

  beginProductsEdit() {
    this.editProducts = !this.editProducts;
    if (this.editProducts) {
      this.getAvailableProducts(true);
    }
  }

  beginDateEdit() {
    this.editDate = !this.editDate;
    this.editProducts = this.editDate;
    if (
      this.editDate &&
      this.canEditReservation &&
      this.reservation.fromDate &&
      this.reservation.toDate
    ) {
      setTimeout(() => {
        this.calendar.currentYear = moment(this.reservation.fromDate).get(
          'year',
        );
        this.calendar.currentMonth = moment(this.reservation.fromDate).get(
          'month',
        );
        this.onMonthChange(true);
        this.datesUpdated();
        if (this.editProducts) {
          this.getAvailableProducts(true);
        }
      }, 500);
    }
  }

  beginDeliveriesEdit() {
    
    if(this.reservation.deliveryInformation && this.reservation.deliveryInformation.scheduleDate){
      this.reservation.deliveryInformation.scheduleDate = moment(this.reservation.deliveryInformation.scheduleDate).toDate();
    }
    if(this.reservation.collectionInformation && this.reservation.collectionInformation.scheduleDate){
      this.reservation.collectionInformation.scheduleDate = moment(this.reservation.collectionInformation.scheduleDate).toDate();
    }

    if(this.reservation.deliveryInformation && this.reservation.deliveryInformation.areaID){
      this.getAvailability(moment(this.reservation.fromDate).startOf('month').format('YYYY-MM-DD'), false, false, true);
      this.getAvailability(moment(this.reservation.toDate).startOf('month').format('YYYY-MM-DD'), false, true, false);
    }

    this.editDeliveries = !this.editDeliveries;
    this.editProducts = this.editDeliveries;
    if (
      this.editDeliveries &&
      this.canEditReservation &&
      this.reservation.fromDate &&
      this.reservation.toDate
    ) {
      setTimeout(() => {
        this.calendar.currentYear = moment(this.reservation.fromDate).get(
          'year',
        );
        this.calendar.currentMonth = moment(this.reservation.fromDate).get(
          'month',
        );
        this.onMonthChange(true);
        this.datesUpdated();
        if (this.editProducts) {
          this.getAvailableProducts(true);
        }
      }, 500);
    }
  }

  getSelectedProducts() {
    return this.products.filter((x) => {
      return x.selected;
    });
  }

  getSelectedCount(accessories) {
    return accessories
      ? accessories.filter((x) => {
          return x.selected;
        }).length
      : 0;
  }

  getAvailableProducts(initial = false) {
    if (this.reservation.fromDate && this.reservation.toDate) {
      this.bikesLoading = true;
      this.listBikesNotAvailable = [];
      this.rentalsService
        .getAvailableRentalProducts(
          this.helpersService.getPartnerId(),
          moment(this.reservation.fromDate).format('YYYY-MM-DD HH:mm'),
          moment(this.reservation.toDate).format('YYYY-MM-DD HH:mm'),
          this.reservation.id,
          this.reservation.isDemo
        )
        .subscribe(
          (products) => {
            products.forEach((product) => {
              var found = this.reservation.reservedProducts
                .filter((x) => {
                  return x.productID === product.id;
                })
                .pop();
              if (found) {
                product.selected = true;
                if (product.requredAccessoryOptions) {
                  product.requredAccessoryOptions.forEach((accessory) => {
                    if (
                      found.reservedAccessories &&
                      found.reservedAccessories.length > 0
                    ) {
                      var accessoryFound = found.reservedAccessories
                        .filter((x) => {
                          return x.accessoryID === accessory.id;
                        })
                        .pop();
                      if (accessoryFound) {
                        accessory.selected = true;
                      }
                    }
                  });
                  product.requredAccessoryOptions =
                    product.requredAccessoryOptions.sort((x, y) => {
                      if (x.selected && !y.selected) return -1;
                      else if (!x.selected && y.selected) return 1;
                      else return 0;
                    });
                }
                if (product.accessoryOptions) {
                  product.accessoryOptions.forEach((accessory) => {
                    if (
                      found.reservedAccessories &&
                      found.reservedAccessories.length > 0
                    ) {
                      var accessoryFound = found.reservedAccessories
                        .filter((x) => {
                          return x.accessoryID === accessory.id;
                        })
                        .pop();
                      if (accessoryFound) {
                        accessory.selected = true;
                      }
                    }
                  });
                  product.accessoryOptions = product.accessoryOptions.sort(
                    (x, y) => {
                      if (x.selected && !y.selected) return -1;
                      else if (!x.selected && y.selected) return 1;
                      else return 0;
                    },
                  );
                }
              }
            });

            this.listBikesNotAvailable =
              this.reservation.reservedProducts.filter((x) => {
                return (
                  products
                    .map((y) => {
                      return y.id;
                    })
                    .indexOf(x.productID) === -1
                );
              });

            this.products = products.sort((x, y) => {
              if (x.selected && !y.selected) return -1;
              else if (!x.selected && y.selected) return 1;
              else return 0;
            });

            this.filteredProducts = this.products;
            this.bikesLoading = false;
          },
          (err) => {
            this.bikesLoading = false;
          },
        );
    }
  }

  addProduct(selectedProduct) {
    var product = this.products
      .filter((x) => {
        return x.id === selectedProduct.id;
      })
      .pop();
    if (product.selected) {
      product.selected = false;
    } else {
      product.selected = true;
      //this.addAccessoriesToProduct(product);
    }
  }

  addAccessory(accessory) {
    if (accessory.selected) {
      accessory.selected = false;
    } else {
      accessory.selected = true;
    }
  }

  hasRequiredAccessory(selectedProduct) {
    var product = this.products
      .filter((x) => {
        return x.id === selectedProduct.id;
      })
      .pop();
    const required = product?.requredAccessoryOptions ? product.requredAccessoryOptions : [];
    return required.length > 0 && this.allRequiredAccessoryGroupsSelected(required);
  }

  // Group the accessories linked to this product by category, so selecting any one
  // linked accessory in each required category (e.g. one of the linked pedals) satisfies it
  allRequiredAccessoryGroupsSelected(requiredAccessories) {
    const groups = new Map<string, boolean>();
    requiredAccessories.forEach((x) => {
      const key = x.categoryName;
      groups.set(key, groups.get(key) || (!!x.selected && x.available !== false));
    });
    return [...groups.values()].every((selected) => selected);
  }

  isAccessoryAlreadyUsed(accessory, type) {
    var accessoryUsed = false;
    if (
      this.products.filter((x) => {
        return x.selected;
      }).length > 0
    ) {
      this.products
        .filter((x) => {
          return x.selected;
        })
        .forEach((x) => {
          if (
            type === 'REQUIRED_ACCESSORY' &&
            x.requredAccessoryOptions &&
            x.requredAccessoryOptions.filter((y) => {
              return y.selected && y.id == accessory.id;
            }).length > 0
          ) {
            accessoryUsed = true;
          }
          if (
            type === 'OPTIONAL_ACCESSORY' &&
            x.accessoryOptions &&
            x.accessoryOptions.filter((y) => {
              return y.selected && y.id == accessory.id;
            }).length > 0
          ) {
            accessoryUsed = true;
          }
        });
    }
    return accessoryUsed;
  }

  isValid() {
    var selectedProductsHasRequiredOptions = this.getSelectedProducts().every((x) => {
      const required = x.requredAccessoryOptions ? x.requredAccessoryOptions : [];
      return (!x.requiresAccessories || required.length > 0) && this.allRequiredAccessoryGroupsSelected(required);
    });
    return (
      this.getSelectedProducts().length > 0 &&
      selectedProductsHasRequiredOptions
    );
  }

  isDateChangeValid() {
    if (this.overrideDateControl || this.reservation.overrideDate) {
      return (
        this.reservation.fromDate &&
        this.reservation.toDate &&
        this.reservation.toDate > this.reservation.fromDate &&
        (this.selectedTimeUnit || this.reservation.rentalDays)
      );
    } else {
      return (
        this.reservation.toDate &&
        this.reservation.selectedSlot &&
        this.reservation.selectedDuration
      );
    }
  }

  isDeliveryChangeValid(){
    var deliveryValid = false;
    var collectionValid = false;
    
    if((this.reservation.deliveryInformation && !this.reservation.deliveryInformation.isDelivery) || (this.reservation.deliveryInformation && this.reservation.deliveryInformation.isDelivery && this.reservation.deliveryInformation.scheduleDate && this.reservation.deliveryInformation.areaID && this.reservation.deliveryInformation.slot)){
      deliveryValid = true;
    }
    if((this.reservation.collectionInformation && !this.reservation.collectionInformation.isCollection) || (this.reservation.collectionInformation && this.reservation.collectionInformation.isCollection && this.reservation.collectionInformation.scheduleDate && moment(this.reservation.collectionInformation.scheduleDate).toDate() > this.reservation.fromDate && this.reservation.collectionInformation.areaID && this.reservation.collectionInformation.slot)){
      collectionValid = true;
    }

    return deliveryValid && collectionValid
  }

  updateReservationProducts() {
    this.savingReservationProducts = true;
    if(this.reservation.fromDate &&
      this.reservation.toDate &&
      this.showFlexibleOptions()){
      this.datesUpdated();
    }
    var data = {
      id: this.reservation.id,
      defaultPartnerID: this.reservation.defaultPartnerID,
      fromDate: moment(this.reservation.fromDate).format('YYYY-MM-DD HH:mm'),
      toDate: moment(this.reservation.toDate).format('YYYY-MM-DD HH:mm'),
      overrideDate: this.overrideDateControl || this.reservation.overrideDate,
      timeUnitID:
        (this.overrideDateControl || this.reservation.overrideDate) &&
        this.selectedTimeUnit &&
        this.selectedTimeUnit.id
          ? this.selectedTimeUnit.id
          : null,
      unitType: this.selectedTimeUnit ? this.selectedTimeUnit.unitType : null,
      RentalDays: this.reservation.rentalDays,
      linkedRentalProducts: this.products
        .filter((product) => {
          return product.selected;
        })
        .map((product) => {
          return {
            ProductID: product.id,
            AccessoryOptions: product.accessoryOptions
              ? product.accessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: false };
                  })
              : [],
            RequiredAccessoryOptions: product.requredAccessoryOptions
              ? product.requredAccessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: true };
                  })
              : [],
          };
        }),        
        deliveryInformation: this.reservation.deliveryInformation.isDelivery ? this.reservation.deliveryInformation : null,
        collectionInformation: this.reservation.collectionInformation.isCollection ? this.reservation.collectionInformation : null
    };

    if(data && data.deliveryInformation && data.deliveryInformation.isDelivery && data.deliveryInformation.scheduleDate){
      data.deliveryInformation.scheduleDate = moment(data.deliveryInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.collectionInformation && data.collectionInformation.isCollection && data.collectionInformation.scheduleDate){
      data.collectionInformation.scheduleDate = moment(data.collectionInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.deliveryInformation && data.deliveryInformation.fullAddress && data.deliveryInformation.fullAddress.address){
      data.deliveryInformation.fullAddress = data.deliveryInformation.fullAddress.address;
    }
    if(data && data.collectionInformation && data.collectionInformation.fullAddress && data.collectionInformation.fullAddress.address){
      data.collectionInformation.fullAddress = data.collectionInformation.fullAddress.address;
    }

    this.rentalsService.updateReservationProducts(data).subscribe(
      (res) => {
        this.savingReservationProducts = false;
        this.reservation = res;
        this.editProducts = false;
        this.updateReservationData.emit(res);
      },
      (err) => {
        this.savingReservationProducts = false;
      },
    );
  }

  updateReservationDate() {
    this.savingReservationDates = true;
    var data = {
      id: this.reservation.id,
      defaultPartnerID: this.reservation.defaultPartnerID,
      fromDate: moment(this.reservation.fromDate).format('YYYY-MM-DD HH:mm'),
      toDate: moment(this.reservation.toDate).format('YYYY-MM-DD HH:mm'),
      overrideDate: this.overrideDateControl || this.reservation.overrideDate,
      timeUnitID:
        (this.overrideDateControl || this.reservation.overrideDate) &&
        this.selectedTimeUnit &&
        this.selectedTimeUnit.id
          ? this.selectedTimeUnit.id
          : null,
      unitType: this.selectedTimeUnit ? this.selectedTimeUnit.unitType : null,
      RentalDays: this.reservation.rentalDays,
      linkedRentalProducts: this.products
        .filter((product) => {
          return product.selected;
        })
        .map((product) => {
          return {
            ProductID: product.id,
            AccessoryOptions: product.accessoryOptions
              ? product.accessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: false };
                  })
              : [],
            RequiredAccessoryOptions: product.requredAccessoryOptions
              ? product.requredAccessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: true };
                  })
              : [],
          };
        }),
    };
    this.rentalsService.updateReservationProducts(data).subscribe(
      (res) => {
        this.savingReservationDates = false;
        this.reservation = res;
        this.editDate = false;
        this.editProducts = false;
        this.updateReservationData.emit(res);
      },
      (err) => {
        this.savingReservationDates = false;
      },
    );
  }

  updateAddress(event, type){
    if (
      !this.busySavingAddress &&
      (type === 'Addressline1' ||
        type === 'Addressline2' ||
        type === 'City' ||
        type === 'State' ||
        type === 'Country' ||
        type === 'ZipCode')
    ) {
      this.busySavingAddress = true;

      var data = {
        ReservationID: this.reservation.id,
        DefaultPartnerID: this.partner.ID,
        Addressline1: this.reservation.addressline1,
        Addressline2: this.reservation.addressline2,
        City: this.reservation.city,
        State: this.reservation.state,
        Country: this.reservation.country,
        ZipCode: this.reservation.zipCode
      }
      
      this.rentalsService.updateRentalReservationAddress(data).subscribe(() => {
          // Reservation address updated

          // Return component to view only
          if (event !== null) {
            event.deactivate();
          }
          this.busySavingAddress = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.rentals.booking.address_information_updated',
            ),
          });
        },
        (error) => {
          this.busySavingAddress = false
        }
      );
    }
  }

  updateCyclist(event, type) {
    if (
      !this.busySavingCustomer &&
      (type === 'PhoneNumber' ||
        type === 'Name' ||
        type === 'Surname' ||
        type === 'DateOfBirth' ||
        (type === 'Email' && this.validateEmail()))
    ) {
      this.busySavingCustomer = true;
      this.cyclistService.getCyclistById(this.cyclist.ID).subscribe(
        (result) => {
          var cyclist = { ...result, ...this.cyclist, PartnerID : this.reservation.defaultPartnerID };
          if (type === 'PhoneNumber') {
            cyclist.PhoneNumber = this.cyclist.PhoneNumber;
          }
          if (type === 'Name') {
            cyclist.Name = this.cyclist.Name;
          }
          if (type === 'Surname') {
            cyclist.Surname = this.cyclist.Surname;
          }
          if (type === 'Email') {
            cyclist.Email = this.cyclist.Email;
          }
          if (type === 'DateOfBirth') {
            cyclist.DateOfBirth = new Date(
              moment(this.cyclist.DateOfBirth).format('YYYY-MM-DDTHH:mm') + 'Z',
            );
          }
          this.userService.updateCustomer(cyclist).subscribe(
            (updatedCyclist) => {
              if (
                updatedCyclist.Data.DateOfBirth &&
                updatedCyclist.Data.DateOfBirth.toString().indexOf('Z') ===
                updatedCyclist.Data.DateOfBirth.toString().length - 1
              ) {
                updatedCyclist.Data.DateOfBirth =
                  updatedCyclist.Data.DateOfBirth.substring(
                    0,
                    updatedCyclist.Data.DateOfBirth.length - 1,
                  );
              }
              updatedCyclist.Data.DateOfBirth =
                updatedCyclist.Data.DateOfBirth &&
                updatedCyclist.Data.DateOfBirth.length > 0
                ? moment(updatedCyclist.Data.DateOfBirth).format('YYYY-MM-DD')
                  : null;

              this.cyclist = updatedCyclist.Data;
              if (event !== null) {
                event.deactivate();
              }
              this.busySavingCustomer = false;
              this.messageService.add({
                life: 5000,
                detail: this.translate.instant(
                  'bikeshop.modal.update_job_card.job_card.cyclist_information_updated',
                ),
              });
            },
            (error) => {
              this.busySavingCustomer = false;
              if (error.statusText === 'Conflict') {
                this.confirmationService.confirm({
                  key: 'jobcard',
                  header: this.translate.instant(
                    'messages.error_updating_jobcard_user_title',
                  ),
                  message: this.translate.instant(
                    'messages.error_updating_jobcard_user',
                  ),
                  acceptLabel: this.translate.instant('general.yes'),
                  accept: () => {},
                  rejectLabel: this.translate.instant('general.no'),
                });
              }
            },
          );
        },
        (error) => {},
      );
    }
  }

  validateEmail() {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.cyclist.Email).toLowerCase());
  }

  calculateReservationTime() {
    var timeDiff = moment(this.reservation.toDate).diff(
      this.reservation.fromDate,
      'hour',
      false,
    );
    return {
      weeks: Math.floor(Math.floor(timeDiff / 24) / 7),
      days: Math.floor(timeDiff / 24),
      hours: timeDiff % 24,
    };
  }

  setTempDisabledDates(fromDate: Date, toDate: Date) {
    this.disabledDates = [];
    var i = 0;
    for (var d = fromDate; d <= toDate; d = moment(d).add(1, 'day').toDate()) {
      this.disabledDates.push(d);
    }
  }

  onMonthChange(initialLoad = false) {
    this.loadingAvailability = true;
    var startDate = moment(
      new Date(this.calendar.currentYear, this.calendar.currentMonth, 1),
    ).format('YYYY-MM-DD');
    var endDate = moment(
      moment(startDate).endOf('month').add(1, 'day').toDate(),
    ).format('YYYY-MM-DD');
    this.setTempDisabledDates(new Date(startDate), new Date(endDate));
    this.rentalsService
      .getRentalAvailability(this.partner.ID, startDate, endDate)
      .subscribe(
        (availability) => {
          this.disabledDates = availability.unavailableDates.map((x) => {
            return new Date(x.date);
          });
          this.availableDates = availability.availableDates;
          if (this.reservation.fromDate && initialLoad) {
            this.fromDateSelected(this.reservation.fromDate, initialLoad);
          }
          this.loadingAvailability = false;
        },
        (err) => {
          this.loadingAvailability = false;
        },
      );
  }

  fromDateSelected(event, initialLoad = false) {
    var selectedDate = this.availableDates
      .filter((x: any) => {
        return (
          moment(x.date).format('YYYY-MM-DD') ===
          moment(event).format('YYYY-MM-DD')
        );
      })
      .pop();
    if (selectedDate && selectedDate.availableSlots) {
      this.availableSlots = selectedDate.availableSlots.map((x: any) => {
        return { ...x, label: moment('1970-01-01T' + x.value).format('h:mma') };
      });

      this.reservation.toDate = !initialLoad ? null : this.reservation.toDate;
      this.reservation.selectedSlot = !initialLoad
        ? null
        : this.reservation.selectedSlot;
      this.reservation.selectedDuration = !initialLoad
        ? null
        : this.reservation.selectedDuration;
      if (initialLoad && this.availableSlots) {
        var time = moment(this.reservation.fromDate).format('HH:mm:ss');
        var slot = this.availableSlots
          .filter((x) => {
            return x.value === time;
          })
          .pop();
        if (slot) {
          this.slotSelected(slot, initialLoad);
        }
      }
    }
  }

  slotSelected(slot: any, initialLoad = false) {
    this.reservation.selectedSlot = slot;
    this.reservation.selectedDuration = null;
    if (initialLoad) {
      var duration = this.calculateReservationTime();
      if (slot && slot.durations) {
        if (duration.hours > 0) {
          var selectedDuration = slot.durations
            .filter((x) => {
              return x.unit === duration.hours && x.unitType === 'Hour';
            })
            .pop();
          if (selectedDuration) {
            this.durationSelected(selectedDuration, initialLoad);
          }
        } else if (duration.weeks > 0) {
          var selectedDuration = slot.durations
            .filter((x) => {
              return x.unit === duration.weeks && x.unitType === 'Week';
            })
            .pop();
          if (selectedDuration) {
            this.durationSelected(selectedDuration, initialLoad);
          }
        } else if (duration.days > 0) {
          var selectedDuration = slot.durations
            .filter((x) => {
              return x.unit === duration.days && x.unitType === 'Day';
            })
            .pop();
          if (selectedDuration) {
            this.durationSelected(selectedDuration, initialLoad);
          }
        }
      }
    }
  }

  durationSelected(duration: any, initialLoad = false) {
    this.reservation.selectedDuration = duration;
    var fromDate =
      moment(this.reservation.fromDate).format('YYYY-MM-DD') +
      'T' +
      this.reservation.selectedSlot.value;
    var toDate = moment(
      moment(this.reservation.fromDate).format('YYYY-MM-DD') +
        'T' +
        this.reservation.selectedSlot.value,
    )
      .add(
        this.reservation.selectedDuration.unit,
        this.reservation.selectedDuration.unitType,
      )
      .format('YYYY-MM-DDTHH:mm:ss');
    var timeUnitID = this.reservation.selectedDuration.timeUnitID;
    this.reservation.fromDate = moment(fromDate).toDate();
    this.reservation.toDate = moment(toDate).toDate();
    if (this.reservation.fromDate && this.reservation.toDate) {
      this.getAvailableProducts(initialLoad);
    } else {
      this.products = [];
      this.filteredProducts = [];
    }
  }

  datePickerFocused(event) {
    this.selectedProductsTmp = this.products
      .filter((x) => {
        return x.selected;
      })
      .map((x) => {
        return x.id;
      });
  }

  datePickerClosed(event) {
    if (this.reservation.fromDate && !this.reservation.toDate) {
      this.getAvailableProducts();
    }
  }

  dateOverrideUpdated() {
    if (this.overrideDateControl) {
      this.datesUpdated();
    }
  }

  datesUpdated() {
    if(!this.editDeliveries || this.rentalStoreRules.allowFlexibleRentalOptions){
      this.selectedTimeUnit = null;
    }    
    this.reservation.rentalDays = 0;
    this.reservation.useFlexibleTimes = false;
    if (
      this.reservation.fromDate &&
      this.reservation.toDate &&
      this.showFixedSlots()
    ) {
      this.getAvailableProducts(false);

      var hours = 0;
      var days = 0;
      var weeks = 0;
      var months = 0;
      hours = moment(this.reservation.toDate).diff(
        this.reservation.fromDate,
        'hours',
        false,
      );
      days = moment(this.reservation.toDate).diff(
        this.reservation.fromDate,
        'days',
        false,
      );
      weeks = moment(this.reservation.toDate).diff(
        this.reservation.fromDate,
        'weeks',
        false,
      );
      months = moment(this.reservation.toDate).diff(
        this.reservation.fromDate,
        'months',
        false,
      );

      if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 4 && x.unit === months;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 4 && x.unit === months;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 3 && x.unit === weeks;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 3 && x.unit === weeks;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 2 && x.unit === days;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 2 && x.unit === days;
          })
          .pop();
      } else if (
        this.availableTimeUnits.filter((x) => {
          return x.unitTypeID === 1 && x.unit === hours;
        }).length > 0
      ) {
        this.selectedTimeUnit = this.availableTimeUnits
          .filter((x) => {
            return x.unitTypeID === 1 && x.unit === hours;
          })
          .pop();
      }
    } else if (
      this.reservation.fromDate &&
      this.reservation.toDate &&
      this.showFlexibleOptions()
    ) {
      this.getAvailableProducts(false);

      var hours = moment(this.reservation.toDate).diff(
        this.reservation.fromDate,
        'hours',
      );
      var days = Math.round(
        moment(this.reservation.toDate).diff(
          this.reservation.fromDate,
          'days',
          true,
        ),
      );

      if (this.rentalStoreRules.flexibleReservationConfiguration.addExtraDay) {
        days += 1;
      }
      if (days == 0) {
        days += 1;
      }

      if (hours / 24.0 > days) {
        this.rentalDaysMessage = 'OVER';
        this.reservation.rentalDays = days + 1;
      } else if (hours / 24.0 < days) {
        this.rentalDaysMessage = 'UNDER';
        this.reservation.rentalDays = days;
      } else {
        this.rentalDaysMessage = 'EXACT';
        this.reservation.rentalDays = days;
      }
      if(this.reservation.rentalDays && this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 2 && this.reservation.rentalDays > this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue){
        this.reservation.rentalDays = this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue;
      }
      this.reservation.useFlexibleTimes = true;
    } else {
      this.products = [];
      this.filteredProducts = [];
    }
  }

  showFixedSlots() {
    return (
      !this.rentalStoreRules.allowFlexibleRentalOptions ||
      (this.rentalStoreRules.allowFixedRentalOptions &&
        moment(this.reservation.fromDate).format('YYYY-MM-DD') ==
          moment(this.reservation.toDate).format('YYYY-MM-DD'))
    );
  }

  showFlexibleOptions() {
    return (
      !this.rentalStoreRules.allowFixedRentalOptions ||
      (this.rentalStoreRules.allowFlexibleRentalOptions &&
        moment(this.reservation.fromDate).format('YYYY-MM-DD') !==
          moment(this.reservation.toDate).format('YYYY-MM-DD'))
    );
  }

  getFromDateTime() {
    return moment(this.reservation.fromDate).format('h:mma');
  }

  clearAffiliate() {
    this.affiliateID = null;
    this.updateAffiliate();
  }

  updateAffiliate() {
    const data = {
      DefaultPartnerID: this.reservation.defaultPartnerID,
      ReservationID: this.reservation.id,
      AffiliateID: this.affiliateID,
    };
    
    this.rentalsService
      .updateReservationAffiliate(data)
      .subscribe((reservation: any) => {
        this.updateReservationData.emit(reservation);
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.booking.reservation_affiliate_updated',
          ),
        });
        this.editAffiliate = false;
      });
  }

  deliveryDateSelected(event){
    this.setBookingDate(false, "DELIVERY");
  }

  collectionDateSelected(event){
    this.setBookingDate(false, "COLLECTION");
  }

  onDeliveryMonthChange(date){
    
    this.deliveryTimeSlots = [];
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate,false,false,true);
  }

  onCollectionMonthChange(date){
    this.collectionTimeSlots = [];
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate,false,true,false);
  }

  selectDeliveryTimeSlot(event){
    this.reservation.deliveryInformation.slot = event.value;

    this.reservation.fromDate = moment(moment(this.reservation.deliveryInformation.scheduleDate).format('YYYY-MM-DD')+"T"+this.reservation.deliveryInformation.slot.slotStartTime).toDate();
    this.datesUpdated()
    this.getAvailableProducts();
    this.getMinCollectionDate();
    this.getMaxCollectionDate();
    this.getAvailability(this.reservation.fromDate,false,true,false);
  }

  selectCollectionTimeSlot(event){
    this.reservation.collectionInformation.slot = event.value;

    this.reservation.toDate = moment(moment(this.reservation.collectionInformation.scheduleDate).format('YYYY-MM-DD')+"T"+this.reservation.collectionInformation.slot.slotEndTime).toDate();
    this.datesUpdated();
    this.getAvailableProducts();
  }

  searchAddress(address, type){
    this.addressSearch = address.query;
    if (type === 'COLLECTION') {
      this.reservation.collectionInformation.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    } else {
      this.reservation.deliveryInformation.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    }
  }

  onAddressSelect(event, type){
    if (type === 'COLLECTION') {
      this.collectionAddressLoading = true;
      this.reservation.collectionInformation.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    } else {
      this.deliveryAddressLoading = true;
      this.reservation.deliveryInformation.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    }
  }

  async getAddressPlaceDetails(type, locationFromAddress = false) {
    if (type === 'COLLECTION') {
      await this.collectionsService
        .getAddressOptions(this.reservation.collectionInformation.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.reservation.collectionInformation.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.reservation.collectionInformation.googlePlaceID) {
            this.getLocationFromAddress(
              this.reservation.collectionInformation.fullAddress.address,
              type,
            );
          }
        });
    } else {
      await this.collectionsService
        .getAddressOptions(this.reservation.deliveryInformation.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.reservation.deliveryInformation.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.reservation.deliveryInformation.googlePlaceID) {
            this.getLocationFromAddress(
              this.reservation.deliveryInformation.fullAddress.address,
              type,
            );
          }
        });
    }
  }

  getLocationFromAddress(address, type, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
          (this.partner.Country === 'GB' && this.addressSearch.length <= 8
            ? ', ' + this.addressSearch + ', UK'
            : ''),
      )
      .subscribe(async (res) => {
        const data = {
          PartnerID: this.reservation.defaultPartnerID,
          IsCollection: type === 'COLLECTION',
          IsDelivery: type === 'DELIVERY',
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };
        if (
          (type === 'COLLECTION' && !this.reservation.collectionInformation.googlePlaceID) ||
          (type === 'DELIVERY' && !this.reservation.deliveryInformation.googlePlaceID)
        ) {
          await this.getAddressPlaceDetails(type, true);
          return;
        }
        this.collectionsService.checkRentalAddressInRange(data).subscribe(
          (addressInfo: any) => {
            if (
              addressInfo &&
              addressInfo.partnerID == this.reservation.defaultPartnerID
            ) {
              if (type === 'COLLECTION') {
                this.collectionsService
                  .getGooglePlaceInfo(this.reservation.collectionInformation.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.reservation.collectionInformation.addressOutOfRange = false;
                this.reservation.collectionInformation.distanceToPartner = addressInfo.distanceToStore;
                this.reservation.collectionInformation.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.reservation.collectionInformation.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, true, false);
              } else {
                this.collectionsService
                  .getGooglePlaceInfo(this.reservation.deliveryInformation.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.reservation.deliveryInformation.addressOutOfRange = false;
                this.reservation.deliveryInformation.distanceToPartner = addressInfo.distanceToStore;
                this.reservation.deliveryInformation.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.reservation.deliveryInformation.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, false, true);
              }
            } else {
              if (type === 'COLLECTION') {
                this.reservation.collectionInformation.addressOutOfRange = true;
                this.reservation.collectionInformation.distanceToPartner = -1;
                this.reservation.collectionInformation.areaID = 0;
                this.collectionAddressLoading = false;
                this.reservation.collectionInformation.timeSlot = {};
                this.reservation.collectionInformation.scheduleDate = null;
              } else {
                this.reservation.deliveryInformation.addressOutOfRange = true;
                this.reservation.deliveryInformation.distanceToPartner = -1;
                this.reservation.deliveryInformation.areaID = 0;
                this.deliveryAddressLoading = false;
                this.reservation.deliveryInformation.timeSlot = {};
                this.reservation.deliveryInformation.scheduleDate = null;
              }
            }
          },
          (err) => {
            if (type === 'COLLECTION') {
              this.reservation.collectionInformation.addressOutOfRange = true;
              this.reservation.collectionInformation.distanceToPartner = -1;
              this.reservation.collectionInformation.areaID = 0;
              this.collectionAddressLoading = false;
              this.reservation.collectionInformation.timeSlot = {};
              this.reservation.collectionInformation.scheduleDate = null;
            } else {
              this.reservation.deliveryInformation.addressOutOfRange = true;
              this.reservation.deliveryInformation.distanceToPartner = -1;
              this.reservation.deliveryInformation.areaID = 0;
              this.deliveryAddressLoading = false;
              this.reservation.deliveryInformation.timeSlot = {};
              this.reservation.deliveryInformation.scheduleDate = null;
            }
          },
        );
      });
  }

  setAddressInfo(placeInfo, type) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        if (type === 'COLLECTION') {
          this.reservation.collectionInformation.addressDetails = addressDetails;
          this.reservation.collectionInformation.postalCode = addressDetails.postal_code;
        } else {
          this.reservation.deliveryInformation.addressDetails = addressDetails;
          this.reservation.deliveryInformation.postalCode = addressDetails.postal_code;
          if(!this.reservation.collectionInformation.fullAddress){
            this.reservation.collectionInformation.fullAddress = this.reservation.deliveryInformation.fullAddress;
            this.reservation.collectionInformation.addressDetails = addressDetails;
            this.reservation.collectionInformation.postalCode = addressDetails.postal_code;
            this.reservation.collectionInformation.areaID = this.reservation.deliveryInformation.areaID;
            this.getAvailability(this.reservation.fromDate, false, true, false);
          }
        }
      }
    }
  }

  getAvailability(
    fromDate: string,
    reset = true,
    collection = false,
    delivery = false,
  ) {
    if (
      (collection && this.reservation.collectionInformation.areaID) ||
      (delivery && this.reservation.deliveryInformation.areaID)
    ) {
      const data = {
        PartnerID: this.reservation.defaultPartnerID,
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate)
          .add('month', 2)
          .endOf('month')
          .format('YYYY-MM-DD'),
        CurrentLocalTime: moment().toDate() < moment(fromDate).add('days', -7).toDate() ? moment().add('days', -7).format('YYYY-MM-DDTHH:mm:ss') : moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        IsCollection: collection,
        IsDelivery: delivery,
        AreaID: collection
          ? this.reservation.collectionInformation.areaID
          : delivery
            ? this.reservation.deliveryInformation.areaID
            : 0,
        //"ServiceTypes": collection ? this.jobcard.Types.map(x=>{return x.TypeID}).join(",") : null
      };
      var invalidDates = JSON.parse(
        JSON.stringify(
          collection
            ? this.disabledCollectionDates
            : delivery
              ? this.disabledDeliveryDates
              : [],
        ),
      );
      invalidDates = invalidDates.map((x) => {
        return new Date(x);
      });
      this.rentalsService.getAvailableDeliveryCollectionDates(data).subscribe(
        (response: any) => {
          if (response.availableDates && response.availableDates.length > 0) {
            if (collection) {
              this.availableCollectionDates = response.availableDates;
            } else {
              this.availableDeliveryDates = response.availableDates;
            }
            response.availableDates.forEach((availableDate: any) => {
              var index = invalidDates
                .map((x) => {
                  return moment(x).format('YYYY-MM-DD');
                })
                .indexOf(
                  moment(availableDate.availableDate).format('YYYY-MM-DD'),
                );
              if (index > -1) {
                invalidDates.splice(index, 1);
              }
            });
            if (collection) {
              this.disabledCollectionDates = invalidDates;
            } else {
              this.disabledDeliveryDates = invalidDates;
            }

            if (!reset) {
              this.setBookingDate(
                reset,
                collection ? 'COLLECTION' : delivery ? 'DELIVERY' : '',
              );
            }
          }
          if (
            response.unavailableDates &&
            response.unavailableDates.length > 0
          ) {
            response.unavailableDates.map((x) => {
              var d = new Date(x.unavailableDate);
              d.setHours(0);
              d.setMinutes(0);
              d.setSeconds(0);
              d.setMilliseconds(0);
              var index = collection
                ? this.disabledCollectionDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  })
                : this.disabledDeliveryDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  });
              if (index === -1) {
                if (collection) {
                  this.disabledCollectionDates.push(d);
                } else {
                  this.disabledDeliveryDates.push(d);
                }
              }
            });
          }
          
          this.collectionAddressLoading = false;
          this.deliveryAddressLoading = false;
        },
        (err) => {
          
          this.collectionAddressLoading = false;
          this.deliveryAddressLoading = false;
        },
      );
    } else {
      
      this.collectionAddressLoading = false;
      this.deliveryAddressLoading = false;
    }
  }

  setBookingDate(reset = false, type) {
    if (type === 'COLLECTION') {
      if (reset) {
        this.collectionTimeSlots = [];
      }

      if (this.reservation.collectionInformation.scheduleDate) {
        if (reset) {
          this.reservation.collectionInformation.timeSlot = {};
        }

        var selectedDate = this.availableCollectionDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.reservation.collectionInformation.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.collectionTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label, slotStartTime: x.slotStartTime, slotEndTime: x.slotEndTime };
          });
          if (this.collectionTimeSlots.length == 1) {
            //this.reservation.collectionInformation.slot = this.collectionTimeSlots[0];
            this.selectCollectionTimeSlot({value : this.collectionTimeSlots[0]});
          } else if (
            this.reservation.collectionInformation &&
            this.reservation.collectionInformation.scheduleTimeSlotStart
          ) {
            var index = this.collectionTimeSlots.findIndex((x) => {
              return x.slotStartTime === this.reservation.collectionInformation.scheduleTimeSlotStart && 
              x.slotEndTime === this.reservation.collectionInformation.scheduleTimeSlotEnd;
            });
            if (index > -1) {
              //this.reservation.collectionInformation.slot = this.collectionTimeSlots[index];
              this.selectCollectionTimeSlot({value : this.collectionTimeSlots[index]});
            }
          }
        }
      }
    } else {
      if (reset) {
        this.deliveryTimeSlots = [];
      }
      if (this.reservation.deliveryInformation.scheduleDate) {
        if (reset) {
          this.reservation.deliveryInformation.timeSlot = {};
        }

        var selectedDate = this.availableDeliveryDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.reservation.deliveryInformation.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.deliveryTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label, slotStartTime: x.slotStartTime, slotEndTime: x.slotEndTime };
          });
          if (this.deliveryTimeSlots.length == 1) {
            //this.reservation.deliveryInformation.slot = this.deliveryTimeSlots[0];
            this.selectDeliveryTimeSlot({value : this.deliveryTimeSlots[0]});
          } else if (
            this.reservation.deliveryInformation &&
            this.reservation.deliveryInformation.scheduleTimeSlotStart
          ) {
            var index = this.deliveryTimeSlots.findIndex((x) => {
              return x.slotStartTime === this.reservation.deliveryInformation.scheduleTimeSlotStart && 
              x.slotEndTime === this.reservation.deliveryInformation.scheduleTimeSlotEnd;
            });
            if (index > -1) {
              //this.reservation.deliveryInformation.slot = this.deliveryTimeSlots[index];
              this.selectDeliveryTimeSlot({value : this.deliveryTimeSlots[index]})
            }
          }
        }

        if(this.minCollectionDate < moment(this.reservation.deliveryInformation.scheduleDate).add(1, 'day').toDate()){
          this.minCollectionDate = moment(this.reservation.deliveryInformation.scheduleDate).add(1, 'day').toDate();
        }   
      }
    }
  }

  getMinCollectionDate(){
    if(this.rentalStoreRules.allowFlexibleRentalOptions){      
      this.minCollectionDate = moment(this.reservation.fromDate).add(this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationValue, this.rentalStoreRules.flexibleReservationConfiguration.mimimumDurationUnitType == 1 ? 'hours' : this.rentalStoreRules.flexibleReservationConfiguration.mimimumDurationUnitType == 2 ? 'days' : 'days').toDate();
    }else{
      this.minCollectionDate = this.reservation.fromDate;
    }     

    if(this.reservation.collectionInformation && this.reservation.collectionInformation.isCollection && moment(this.reservation.fromDate).add(this.rentalStoreRules.minimumRentalDaysForCollection, 'day').toDate() > this.minCollectionDate){      
      this.minCollectionDate = moment(this.reservation.fromDate).add(this.rentalStoreRules.minimumRentalDaysForCollection, 'day').toDate();
    }
  }

  getMaxCollectionDate(){
    if(this.rentalStoreRules.allowFlexibleRentalOptions){
      this.maxCollectionDate = moment(this.reservation.fromDate).add(this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue, this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationUnitType == 1 ? 'hours' : this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationUnitType == 2 ? 'days' : 'days').toDate()
    }    
  }


  updateReservationDeliveries() {
    this.savingReservationDates = true;
    var data = {
      id: this.reservation.id,
      defaultPartnerID: this.reservation.defaultPartnerID,
      fromDate: moment(this.reservation.fromDate).format('YYYY-MM-DD HH:mm'),
      toDate: moment(this.reservation.toDate).format('YYYY-MM-DD HH:mm'),     
      overrideDate: this.overrideDateControl || this.reservation.overrideDate,
      timeUnitID:
        (this.overrideDateControl || this.reservation.overrideDate) &&
        this.selectedTimeUnit &&
        this.selectedTimeUnit.id
          ? this.selectedTimeUnit.id
          : null,
      unitType: this.selectedTimeUnit ? this.selectedTimeUnit.unitType : null,
      RentalDays: this.reservation.rentalDays && this.rentalStoreRules.flexibleReservationConfiguration.minimumDurationUnitType == 2 && this.reservation.rentalDays > this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue ? this.rentalStoreRules.flexibleReservationConfiguration.maximumDurationValue : this.reservation.rentalDays,
      linkedRentalProducts: this.products
        .filter((product) => {
          return product.selected;
        })
        .map((product) => {
          return {
            ProductID: product.id,
            AccessoryOptions: product.accessoryOptions
              ? product.accessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: false };
                  })
              : [],
            RequiredAccessoryOptions: product.requredAccessoryOptions
              ? product.requredAccessoryOptions
                  .filter((accessory) => {
                    return accessory.selected;
                  })
                  .map((accessory) => {
                    return { AccessoryID: accessory.id, Mandatory: true };
                  })
              : [],
          };
        }),
        deliveryInformation: this.reservation.deliveryInformation.isDelivery ? this.reservation.deliveryInformation : null,
        collectionInformation: this.reservation.collectionInformation.isCollection ? this.reservation.collectionInformation : null
    };

    if(data && data.deliveryInformation && data.deliveryInformation.isDelivery && data.deliveryInformation.scheduleDate){
      data.deliveryInformation.scheduleDate = moment(data.deliveryInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.collectionInformation && data.collectionInformation.isCollection && data.collectionInformation.scheduleDate){
      data.collectionInformation.scheduleDate = moment(data.collectionInformation.scheduleDate).format("YYYY-MM-DD");
    }
    if(data && data.deliveryInformation && data.deliveryInformation.fullAddress && data.deliveryInformation.fullAddress.address){
      data.deliveryInformation.fullAddress = data.deliveryInformation.fullAddress.address;
    }
    if(data && data.collectionInformation && data.collectionInformation.fullAddress && data.collectionInformation.fullAddress.address){
      data.collectionInformation.fullAddress = data.collectionInformation.fullAddress.address;
    }

    
    this.rentalsService.updateReservationProducts(data).subscribe(
      (res) => {
        this.savingReservationDates = false;
        this.reservation = res;
        this.editDeliveries = false;
        this.editProducts = false;
        this.updateReservationData.emit(res);
      },
      (err) => {
        this.savingReservationDates = false;
      },
    );
  }

  getReservationServiceIndicators() {
    this.rentalsService.getRentalReservationServiceIndicators(this.reservation.defaultPartnerID, this.reservation.id).subscribe(response=>{
      this.serviceIndicatorRecords = response;      
    });
  }

}
